import dbSchema from '@/backend/src/db/schema'

export default function isFieldRestricted(
  tableName,
  fieldName,
  connectionFieldNames
) {
  try {
    const fieldSchema = dbSchema.objects
      .find((tableSchema) => tableSchema.name === tableName)
      ?.fields.find((fieldSchema) => fieldSchema.name === fieldName)

    if (typeof fieldSchema === 'undefined') return true

    return !!(
      (fieldSchema.requiresOne && fieldSchema.requiresOne.length) ||
      (fieldSchema.source &&
        connectionFieldNames &&
        connectionFieldNames.some((connectionFieldName) =>
          isFieldRestricted(fieldSchema.source, connectionFieldName)
        ))
    )
  } catch (error) {
    console.warn(
      `Tried to access non-existent field ${tableName}.${fieldName}.`
    )
    throw error
  }
}
